import { ActionTypes } from "../constants";

const reduceUser = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_USER_INFO:
            return {...action.data};

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceUser;
